@if (leadStatus !== approvedStatus && showUpload) {
  <div class="ppl-mt20">
    @if(!readonly){
    <nz-form-item class="ppl-form-item pt-2">
      <nz-form-control class="ppl-form-control" [nzSm]="8" [nzXs]="24">
        <p style="font-size:0.929rem;">{{message}}</p>
        <ppl-upload (fileSelected)="onFileSelected($event)" (filesUploaded)="filesUploaded($event)"
          (fileRemoved)="onFileRemoved($event)" (downloadRequested)="onDownloadRequested($event)"
          (uploadError)="onUploadError($event)" [fileList]="fileList" [flow]="entry" [leadId]="leadId"
          [docTypeList]="licences" [showFileList]="false"></ppl-upload>
            <div class="ppl-form-item" *ngIf="fileListInfo?.length">
            </div>
      </nz-form-control>
    </nz-form-item>
    }
  </div>
  }
   <div class="btn-group mt-3 mb-2 d-flex justify-content-start">
        <div class="mr-3">
          <ppl-button *ngIf="isAckSupported" ariaLabel="Acknowledge" label="Acknowledge" icon="fa fa-check"
            [iconPosition]="'left'" [customClass]="'ghost-button'" [disabled]="!canAckSelected"
            (click)="onAcknowledgeClicked()">
          </ppl-button>
        </div>
      </div>
  @if(entry === 'provider' && filedInfo?.providerDocumentDetails.length > 0){
  <ppl-list-table [disableSort]="true" [disableSearch]="true" [tableWidth]="tableWidth"
     [enableActions]="!!showButtons && !readonly" [data]="fileListInfo" [disableSelection]="true"
        (selectionChanged)="onSelectionChange($event)" [cols]="cols" [gridTitle]="false" [pagination]="true"
        [loadPage]="false" (gridAction)="action($event)" [actionButtons]="actionButtons" [selectionDisabler]="isAcked">
      </ppl-list-table>
  
  }
  @else if (entry === 'referral' && filedInfo?.referralDocumentDetails.length > 0) {
  <ppl-list-table [disableSort]="true" [disableSearch]="true" [tableWidth]="tableWidth"
     [enableActions]="!!showButtons && !readonly" [data]="fileListInfo" [disableSelection]="true"
        (selectionChanged)="onSelectionChange($event)" [cols]="cols" [gridTitle]="false" [pagination]="true"
        [loadPage]="false" (gridAction)="action($event)" [actionButtons]="actionButtons" [selectionDisabler]="isAcked">
      </ppl-list-table>
  
  }
  @else if (entry === 'participantEnrollment' && filedInfo?.participantEnrlDocumentDetails?.length > 0) {
  <ppl-list-table [disableSort]="true" [disableSearch]="true" [tableWidth]="tableWidth"
     [enableActions]="!!showButtons && !readonly" [data]="fileListInfo" [disableSelection]="!isAckSupported"
        (selectionChanged)="onSelectionChange($event)" [cols]="cols" [gridTitle]="false" [pagination]="true"
        [loadPage]="false" (gridAction)="action($event)" [actionButtons]="actionButtons" [selectionDisabler]="isAcked">
      </ppl-list-table>
  
  }
  @else if (entry === 'providerEnrollment' && filedInfo?.providerEnrlDocumentDetails?.length > 0) {
  <ppl-list-table [disableSort]="true" [disableSearch]="true" [tableWidth]="tableWidth"
     [enableActions]="!!showButtons && !readonly" [data]="fileListInfo" [disableSelection]="!isAckSupported"
        (selectionChanged)="onSelectionChange($event)" [cols]="cols" [gridTitle]="false" [pagination]="true"
        [loadPage]="false" (gridAction)="action($event)" [actionButtons]="actionButtons" [selectionDisabler]="isAcked">
      </ppl-list-table>
  
  }
  @else if (entry === 'auth' && filedInfo?.consumerAuthDocumentDetailsList?.length > 0) {
  <div class="auth-table-width">
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [tableWidth]="tableWidth"
         [enableActions]="!!showButtons && !readonly" [data]="fileListInfo" [disableSelection]="true"
          (selectionChanged)="onSelectionChange($event)" [cols]="cols" [gridTitle]="false" [pagination]="true"
          [loadPage]="false" (gridAction)="action($event)" [actionButtons]="actionButtons" [selectionDisabler]="isAcked">
        </ppl-list-table>
  </div>
  }
  @else if (summary
    || entry === 'provider' || entry === 'referral'
    || entry === 'participantEnrollment' || entry === 'providerEnrollment' || entry === 'auth') {
  <nz-row>
    <p>No Files Uploaded</p>
  </nz-row>
  }
  
  <div class="filter-panel">
    <ng-template #fileEditDialog let-cancel="cancel">
      <form [formGroup]="uploadForm">
      <nz-form-control nz-tooltip nzTooltipPlacement="topRight">
        <div [ngClass]="{'error': validationErrors['document_type'] }">
          <nz-select formControlName="document_type" id="document_type" 
          pplNzAriaLabel
          nzAriaLabel="Document type" (ngModelChange)="docTypeChanged($event)"
            [nzPlaceHolder]="'Select document type'" [ngClass]="{'error': validationErrors['document_type'] }" nzShowSearch>
            @for(opt of licences; track $index){
            <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
            }
          </nz-select>
      </div>
        @if(uploadForm.get('document_type')?.value === 'OTH'){
        <nz-form-item class="ppl-form-item" style="margin-top: 4px;">
          <nz-form-control class="">
            <div nz-tooltip nzTooltipPlacement="topRight">
              <input class="type-input" nz-input placeholder="Document Name" formControlName="other_type"
                [ngClass]="{'error': validationErrors['other_type'] }" />
            </div>
            @if (validationErrors['other_type']) {
            <span class="pl-1 error-message">{{validationErrors['other_type']}}</span>
            }
          </nz-form-control>
        </nz-form-item>
        }
        @if (validationErrors['document_type']) {
        <span class="pl-1 error-message">{{validationErrors['document_type']}}</span>
        }
      </nz-form-control>
    </form>
    </ng-template>
  </div>